export enum ApiRequestEnum {
	AUTH_LOGIN = 'login',
	AUTH_REGISTER = 'register',
	AUTH_FORGOT_PWD = 'forgotPwd',
	AUTH_RESET_PWD = 'resetPwd',

	APPOINTMENT_CREATE = 'appointment',
	GETALLAPPOINTMENT = 'appointment/filter',
	APPOINTMENT_RESCHEDULE = 'appointment/{{appointment_uuid}}',
	CANCEL_APPOINTMENT = 'appointment/{{appointment_uuid}}/status',

	STUDIO_GET_ALL = 'studio/filter',
	STUDIO_TOP = 'studio/top',
	STUDIO_LIKE = 'studio/{{studio_uuid}}/like',
	STUDIO_DISLIKE = 'studio/{{studio_uuid}}/like/{{likeId}}',
	STUDIO_COMMENT = 'studio/{{studio_uuid}}/review',

	STORE_BY_ID = 'store/name/{{name}}',
	STORES = 'store/filter',
	STORES_TOP = 'store/top',

	ITEMS_BY_STORE_ID = 'store/{{store_uuid}}/item/filter',
	GetStoreItemsForWeb = 'store/{{store_uuid}}/item/web',
	ITEM_BY_ID = 'item/name/{{item_uuid}}',
	ITEMS = 'item/filter',
	ITEM_POST_COMMENT = 'item/{{item_uuid}}/review',
	ITEM_LIKE = 'item/{{item_uuid}}/like',
	ITEM_DISLIKE = 'item/{{item_uuid}}/like/{{like_uuid}}',
	COMPARE_ITEMS = 'aggregate/compareItems',

	BRAND_POPULAR = 'brand/popular',

	BANNER = 'banner/filter',

	METAL_RATES = 'metalRate/filter',

	AGGRIGRATE_GET_ALL_TYPES = 'aggregate/types',
	AGGRIGRATE_BY_LOCATION = 'aggregate/shopsCountByLocation/{{ipAddress}}',
	AGGRIGRATE_MARKETPLACE_ANALYTICS = 'aggregate/marketplaceAnalytics',

	LOCATION_BY_LAT_LONG = 'findAddress',

	PROFILE_UPDATE = 'user/profile',
	DELETE_ACCOUNT = 'user/profile',

	WishlistItems = 'user/wishlist',
	AddItemToWishlist = 'user/wishlist/{{itemId}}',
	DeleteItemToWishlist = 'user/wishlist/{{itemId}}',

	NEWSLETTER_SUBSCRIBE = 'emailSubscription',

	ADDTOCARTITEM = 'item/cart/addToCart',
	GETITEMFROMCART = 'item/cart/getCartData',
	DELETEITEMFROMCART = 'item/cart/deleteFromItemCart',
	REMOVEITEMFROMCART = 'item/cart/removeItemFromItemCart/{{variationId}}',
	GETCHECKOUTDATA = 'item/cart/getCheckoutDetails',
	PHITEMPAYMENTSTATUS = 'items/itemsTransactionStatus/{{order_id}}',
	GetAllCustomJewellery = 'item/customJewellery/filter',
	CustomJewelleryCheckOutDetail = 'item/customJewellery/getCheckoutDetails',
	CustomJewelleryPaymentStatus = 'items/customJewTransactionStatus/{{order_id}}',
	CheckCustomJewPaymentType = 'item/{{itemId}}/checkCustomJewPayment',
	GetReview = 'getReview',
	GetAllItemsForWeb = 'getAllItemsWeb',
	GetCustomJewelleryPriceDetails = 'item/customJewellery/getPriceDetails',
	GetAllCompareData = 'item/compareItems/filter',
	CheckServiceAbility = 'checkserviceAbility',
	CountTotalItem = 'countTotalItem/{{storeId}}',

	GetShippingAddress = 'user/shippingAddress',
	ADDSHIPPINGADDRESS = 'user/shippingAddress',

	GetCustomerOrder = 'itemorder/getAllCustomerOrders',
	GetDeliveryStatus = 'delivery/{{orderId}}/getCustomerOrderDeliveryStatus',

	GetItemOrderId = 'itemorder/{{id}}',
	CancelItemOrder = 'itemorder/cancelItemOrder',
	GetCustomerItemDocketStatus = 'delivery/{{docketId}}/getCustomerItemDocketStatus',
	ORDER_POST_COMMENT = 'itemorder/{{order_id}}/review',
	ORDER_REVIEW = 'itemorder/getAllItemOrderReviews',

	Visior = 'visitor',
	LogOut = 'logout',
	ResendOtp = 'user/resendOtp',
	GetCityAndStateFromZipcode = 'getCityAndStateFromZipcode',

	GetAllItemCategory = "getAllItemCategory",

	GetAllCollectionType = "collectionType/filter",

	GetAllOccasionType = 'occasion/filter',

	GetFestiveOccasionName = 'festiveOccasion/{{name}}',
	GetAllFestiveOccasionItems = 'getAllFestiveOccasionItems',

	GetAllProductType = "productType/filter"
}
